// ВТОРОЙ ШАГ В КОРЗИНЕ - ДОСТАВКА
import {Ymap} from 'modules/yandexMap'

function cartDelivery() {
  console.log('tgn');
  
  $('.js-radiobutton-input').on('change',function(){
    $('.js-radiobutton_delivery').parent().removeClass('delivery-choice__item_active');
    $(this).parents('.js-delivery-choice__item').addClass('delivery-choice__item_active');
    $('.js-radiobutton__descr').css('display','none');
    $(this).parent().siblings('.js-radiobutton__descr').slideToggle();
    if ($(this).parents('.js-delivery-choice__item').find('#cdek_pickup__ymaps').length != 0) {
      this.sdek = new Ymap;
      this.sdek.sdekMap();
    }
    if ($(this).parents('.js-delivery-choice__item').find('#yandex__ymaps').length != 0) {
      this.yandex = new Ymap;
      this.yandex.yandexMap();
    }
    var inf = {
      city_id : $(this).parents('.js-delivery-choice__item').data('city_id'),
      type_id : $(this).parents('.js-delivery-choice__item').data('type_id'),
    }
    $.ajax({
      method: "POST",
      url:'/oa/Select_Shipment/',
      data: inf,
      dataType:'json'
    }).then((data) => {
        console.log(data);
        $('.js-form-order__delivery-method').text($(this).val());
        if ((data.mark != "cdek_pickup" && data.mark != "yandex") || data.pvz != null) {
          $('.js-form-order__btn').prop('disabled',false);
          $('.js-form-order__info-pvz').addClass('m--hidden');
        } else {
          $('.js-form-order__btn').prop('disabled',true);
          $('.js-form-order__info-pvz').removeClass('m--hidden');
        }
        if (data.price != 0) {
          $('.delivery-cost').html(data.price +' <span class="rubles">₽</span>')
          $('.total__price').html(data.total_sum +' <span class="rubles">₽</span>')
        } else {
          $('.delivery-cost').html(0 +' <span class="rubles">₽</span>')
          $('.total__price').html(data.total_sum +' <span class="rubles">₽</span>')
        }
        if (data.hide_calculate == '1') {
          $('.js-form-order__info').removeClass('m--hidden');
        } else {
          $('.js-form-order__info').addClass('m--hidden');
        }
    })
  })
  $(document).ready(function(){
    if ($(this).find('.delivery-choice__item_active')) {
      $('.delivery-choice__item_active').find('.js-radiobutton__descr').slideToggle();
      if ($('.delivery-choice__item_active').find('#cdek_pickup__ymaps').length != 0) {
        this.sdek = new Ymap;
        this.sdek.sdekMap();
      }
      if ($('.delivery-choice__item_active').find('#yandex__ymaps').length != 0) {
        this.yandex = new Ymap;
        this.yandex.yandexMap();
      }
    }
  })

}


export {
  cartDelivery
};
